module.exports = __webpack_public_path__ + "img/DXJ.3e0ee1f5.svg";